





















import { waitForReadystate } from '@/utils/componentHelpers';
import { sync } from 'vuex-pathify';
import mixins from '@/utils/mixins';
import events from '@/mixins/events';
export default mixins(events).extend({
  methods: {
    async appLoad() {
      //
      if (document.querySelector('#bootanim')) {
        var vm = this;
        document.querySelector('#bootanim')?.classList.add('is-starting');

        var loaded = document.getElementsByClassName('is-starting')[0];
        loaded.addEventListener('animationend', function() {
          console.log('The animation has started!');
          // vm.appLoaded = false;
        });
      }
    },
    loadApp(): Promise<any> {
      return new Promise(resolve => {
        setTimeout(async () => {
          if (typeof window === 'undefined') {
            // return resolve();
            await waitForReadystate();
          }

          window.requestAnimationFrame(() => {
            try {
              document.querySelector('#bootanim')?.classList.add('is-loading');
              // load event if its in app
              this.fetchEvent(localStorage.getItem('current__event'))
                .then(() => {
                  console.log('event');
                  resolve();
                })
                .catch(() => {
                  console.log('err laoding app');
                  resolve();
                });
            } catch (err) {
              console.log(err);
            }
            resolve();
          });
        }, 200);
      });
    },
    async endLoad() {
      if (document.querySelector('#bootanim')) {
        var vm = this;
        // document.querySelector('#bootanim')?.classList.remove('is-starting');
        // document.querySelector('#bootanim')?.classList.remove('is-loading');
        await this.$nextTick();

        document.querySelector('#bootanim')?.classList.add('is-destroying');

        var destroyed = document.getElementsByClassName('is-destroying')[0];
        destroyed.addEventListener('animationend', function() {
          console.log('The animation has ended!');
          vm.appLoaded = true;
        });
      }
    },
    async init() {
      this.appLoad();
      await this.loadApp().then(async () => {
        await this.$nextTick();

        await this.endLoad();
      });

      // load data then
      // await this.$nextTick();
    }
  },
  computed: {
    appLoaded: sync<boolean>('app/appLoaded')
  },
  async mounted() {
    this.init();
  },
  async created() {
    await this.$nextTick();
    await waitForReadystate();
    window.addEventListener('load', event => {});
  },
  beforeDestroy() {
    console.log('hello');
  }
});
